import {MItem} from '../../../service/m-item/model/m-item';
import {TStockTransfer} from './t-stock-transfer';

export class TStockTransferItem {
  indexNo: number;
  item: MItem;
  stockTransfer: TStockTransfer;
  qty: number = 0;
  //temp
  printDescription: string;
  stock: number = 0;
  balanceQty: number = 0;
  itemBarcode:string;
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-stock-transfer-out/model/t-stocktransfer-item.ts